import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'

/**
 * Reset view control button
 */
export const ResetViewControl = ({ boundsRef }) => {
  const map = useMap()

  useEffect(() => {
    const controlDiv = L.DomUtil.create(
      'div',
      'leaflet-bar leaflet-control leaflet-control-custom',
    )
    controlDiv.style.backgroundColor = 'white'
    controlDiv.style.width = '30px'
    controlDiv.style.height = '30px'
    controlDiv.style.display = 'flex'
    controlDiv.style.alignItems = 'center'
    controlDiv.style.justifyContent = 'center'
    controlDiv.style.cursor = 'pointer'
    controlDiv.title = 'Reset Zoom'
    controlDiv.innerHTML = `
      <svg fill="#333" width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z"/>
      </svg>`

    controlDiv.onclick = () => {
      if (boundsRef.current) {
        map.fitBounds(boundsRef.current, { padding: [40, 40] })
      }
    }

    const customControl = L.control({ position: 'topleft' })
    customControl.onAdd = () => controlDiv
    customControl.addTo(map)

    return () => {
      customControl.remove()
    }
  }, [map, boundsRef])

  return null
}
